import { useQuery } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getLevelUpCompetencyDetails } from 'services/growth/oneOnOne';

const getData = async ({ employeeId, levelUpCompetencyId, competencyId, levelUpId }) => {
  try {
    const res = await getLevelUpCompetencyDetails({
      employeeId,
      levelUpCompetencyId,
      competencyId,
      levelUpId,
    });
    return res;
  } catch (err) {
    console.error('Failed to fetch competency details : ', err);
  }
};

export const useCompetencySidePanelData = ({ employeeId, levelUpId, competencyId, levelUpCompetencyId }) =>
  useQuery(
    [REACT_QUERY_KEYS.CompetencySidePanel, employeeId, levelUpId, competencyId, levelUpCompetencyId],
    () => {
      if (levelUpCompetencyId || (levelUpId && competencyId)) {
        return getData({
          employeeId,
          levelUpId,
          competencyId,
          levelUpCompetencyId,
        });
      }
    },
    { enabled: !!employeeId }
  );
